// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "/projects/omoney-capital.png",
    title: "OMoney Capital",
    description:
      "OMoney Capital is a comprehensive financial platform that empowers users to make informed investment decisions. It offers expert guidance on mutual funds, SIP, insurance, and tax planning, helping users build wealth effectively.",
    tech_stack: [
      "React - Vite",
      "Tailwind Css",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
    ],
    github_url: "",
    download_url: "",
    demo_url: "https://omoneycapital.com/",
  },
  {
    img: "/projects/careasone.png",
    title: "CareAsOne",
    description:
      "CareAsOne connects families with trusted senior care companies in seconds, while also helping caregivers find rewarding jobs—all in one simple, AI-powered platform.Build your caregiving community network to Find inspiration and empower others.",
    tech_stack: ["Laravel", "Stripe", "Firebase", "Pusher"],
    github_url: "",
    download_url: "",
    demo_url: "https://careasone.com/",
  },
  {
    img: "/projects/inova-juris.png",
    title: "Inova Juris",
    description:
      "Inova Juris is a platform connecting lawyers and clients in Brazil, providing case updates and hearing information from Brazilian courts. Advocates can discuss cases with their team and clients, track finances, and receive notifications on new court updates.",
    tech_stack: ["React", "Redux", "NodeJS", "ExpressJS", "MongoDB"],
    github_url: "",
    download_url: "",
    demo_url: "https://www.inovajuris.com.br/",
  },
  {
    img: "/projects/tastyBites.png",
    title: "Tasty Bites",
    description:
      "Tasty Bites is a food delivery website that allows users to order food from their favorite restaurants. The website features a user-friendly interface, a wide selection of restaurants, and secure COD payment options.\n I built this project using Wordpress in my final year of college project.",
    tech_stack: ["Wordpress", "PHP", "MySQL"],
    github_url: "",
    download_url: "",
    demo_url: "https://tastybites.rf.gd/?i=1",
  },
  {
    img: "/projects/testyBitesApp.png",
    title: "Tasty Bites App",
    description:
      "Tasty Bites is a food delivery app mostoly feature same as website. \n I built this project using Flutter with express JS in my final year of college project.\n My role was to develop the backend and database design with all the APIs. Feel free to download the app and check it out. \n\n🔴 Don't need to create an account for check or test application.\n Just use test@gmail.com as email and password is 123456.",
    tech_stack: ["Flutter", "ExpressJS", "MongoDB", "NodeJS", "Cloudinary"],
    github_url: "",
    download_url: "/projects/Tasty Bites.apk",
    demo_url: "",
  },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
    name: "NodeJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "ReactJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original.svg",
    name: "NextJs",
  },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
  //   name: "Typescript",
  // },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
    name: "Git",
  },
  {
    img: "/technologies/git-hub.png",
    name: "Git Hub",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/firebase/firebase-plain.svg",
    name: "Firebase",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    name: "MongoDB",
  },
  {
    img: "/technologies/aws.png",
    name: "AWS",
  },
  {
    img: "/technologies/socket-io.png",
    name: "socket IO",
  },
  {
    img: "/technologies/vite.png",
    name: "Vite",
  },
  {
    img: "/technologies/laravel.png",
    name: "Laravel",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
    name: "MySQL",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
    name: "Bootstrap",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/materialui/materialui-original.svg",
    name: "Material UI",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
    name: "Figma",
  },
  {
    img: "/technologies/tailwind.png",
    name: "TailwindCSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
    name: "VS Code",
  },
  {
    img: "/technologies/postman.png",
    name: "Postman",
  },
  {
    img: "/technologies/docker.png",
    name: "Docker",
  },
  {
    img: "/technologies/expressJS.png",
    name: "ExpressJS",
  },
  {
    img: "/technologies/php.png",
    name: "PHP",
  },
];

export const stackList2 = {
  programmingLanguages: [
    {
      img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
      name: "JavaScript",
    },
    {
      img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
      name: "NodeJS",
    },
    {
      img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
      name: "Typescript",
    },
    {
      img: "/technologies/php.png",
      name: "PHP",
    },
  ],
  frameworks: [
    {
      img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
      name: "ReactJS",
    },
    {
      img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original.svg",
      name: "NextJs",
    },

    {
      img: "/technologies/expressJS.png",
      name: "ExpressJS",
    },
    {
      img: "/technologies/socket-io.png",
      name: "socket IO",
    },
    {
      img: "/technologies/vite.png",
      name: "Vite",
    },
    {
      img: "/technologies/laravel.png",
      name: "Laravel",
    },
    {
      img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
      name: "Bootstrap",
    },
    {
      img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/materialui/materialui-original.svg",
      name: "Material UI",
    },
    {
      img: "/technologies/tailwind.png",
      name: "TailwindCSS",
    },
  ],
  databases: [
    {
      img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
      name: "MongoDB",
    },
    {
      img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
      name: "MySQL",
    },
  ],
  tools: [
    {
      img: "/technologies/git-hub.png",
      name: "Git Hub",
    },
    {
      img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
      name: "Git",
    },
    {
      img: "/technologies/s3Bucket.png",
      name: "AWS S3",
    },
    {
      img: "/technologies/vercel.png",
      name: "Vercel",
    },
    {
      img: "/technologies/render.png",
      name: "Render",
    },
    {
      img: "/technologies/wordpress.png",
      name: "Wordpress",
    },
    {
      img: "/technologies/postman.png",
      name: "Postman",
    },
    {
      img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
      name: "VS Code",
    },
    {
      img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
      name: "Figma",
    },
    {
      img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/firebase/firebase-plain.svg",
      name: "Firebase",
    },
  ],
  paymentGateways: [
    {
      img: "/technologies/razorpay.png",
      name: "Razorpay",
    },
    {
      img: "/technologies/stripe.png",
      name: "Stripe",
    },
  ],
};
